import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

/**
 * Composant de callback Auth0.
 * Affiche un spinner pendant que le SDK Auth0 traite le retour d'authentification.
 * La navigation post-auth est gérée automatiquement par le SDK (appState.target),
 * ce qui préserve l'URL d'origine avec ses query params (?id=...).
 */
@Component({
  selector: 'app-callback',
  standalone: true,
  template: `
    <div class="callback-container">
      <div class="spinner"></div>
      <p>Authentification en cours...</p>
    </div>
  `,
  styles: [`
    .callback-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      gap: 1rem;
      color: var(--text-primary, #333);
    }
    .spinner {
      width: 40px;
      height: 40px;
      border: 4px solid rgba(0, 0, 0, 0.1);
      border-top-color: var(--primary, #1976d2);
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `]
})
export class CallbackComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.auth.error$.subscribe((error) => {
      if (error) {
        this.router.navigate(['/login']);
      }
    });

    this.route.queryParams.subscribe((params) => {
      if (params['error'] || params['error_description']) {
        this.router.navigate(['/login'], { queryParams: params });
      }
    });
  }
}
